import { Box, Container, Divider, Paper, Typography } from '@mui/material';
import React from 'react';
import { formatPrice } from '../../../utils/utils';
import SwitchCart from '../../../components/switch-cart/switch-cart.component';
import PrescriptionSelector from './components/prescription-selector.component';
import TestPlaceOrderBtn from './components/test-place-order-btn.component';
import useTestCartData from './hooks/useTestCartData';
import PatientInfo from './components/patient-info.component';
import './cart.page.css';

const PlaceOrder = () => {
    const {cart, orderInfo, cartPrice, serviceType} = useTestCartData();

    const testServiceType = Object.hasOwn(orderInfo, 'collectionType') && <Typography><strong>Test Service Type: </strong>{serviceType}</Typography>;

    return (
        <Box className='place-order-container'>
            <Typography className='ext-large-brown-txt' style={{textAlign: 'left'}}>
                Place Order
            </Typography>
            <div style={{paddingBottom: '1.5rem', width: '50%', margin: '0 auto'}}>
                <SwitchCart />
            </div>
            <div className="place-order-content flex-gap">
                <Paper className='patient-info-container'>
                    <PatientInfo />
                    <div className="place-order-info-box">
                        {/* if testType is 1 then this customer have prescription and  */}
                        <Typography variant="h6">Previous Medical Document/Prescriptions</Typography>
                        <Divider />
                        <PrescriptionSelector />
                    </div>
                    <div className="place-order-info-box">
                        <Divider />
                        <div className='cart-step-actions'>
                            <TestPlaceOrderBtn />
                        </div>
                    </div>
                </Paper>
                <Paper className="order-info-container place-order-info-box">
                    <Typography variant="h6">Order Info</Typography>
                    <Typography><strong>Request For: </strong>{orderInfo.orderType}</Typography>
                    {testServiceType}
                    <Typography>{cart.length} item(s) has been added</Typography>
                    <Typography><strong>Total Price: </strong>{formatPrice(cartPrice)}</Typography>
                    <Divider />
                    <div className='space-between'>
                        <Typography variant="h6">Total Amount</Typography>
                        <Typography variant="h6">{formatPrice(cartPrice)}</Typography>
                    </div>
                    <div className='space-between'>
                        <Typography variant="h6">Total Payable Amount</Typography>
                        <Typography variant="h6">{formatPrice(cartPrice)}</Typography>
                    </div>
                </Paper>
            </div>
        </Box>
    );
};

const CartPage = () => {
    return (
        <Container className='doc-cat-content labtest-page'>
            <div className='cart-page-content'>
                {/* {cartPageContent()} */}
                <PlaceOrder />
            </div>
        </Container>
    );
};

export default CartPage;